/* ─────────────────────────────────────────────────────────────
   Medicore footer

   The columns are <details open> in the markup, so a visitor whose
   JavaScript never arrives gets every column expanded - the whole
   footer readable, just taller. This script closes them on small
   screens and re-opens them above the breakpoint, which is the safe
   direction for the failure to run in.
   ───────────────────────────────────────────────────────────── */
(function () {
  'use strict';

  var MOBILE_QUERY = '(max-width: 767px)'; // matches footer-medicore.css

  function setup(footer) {
    var columns = Array.prototype.slice.call(footer.querySelectorAll('[data-mcf-col]'));
    if (!columns.length) return;

    var accordion = footer.classList.contains('mcf--accordion');
    var mq = window.matchMedia(MOBILE_QUERY);

    function apply() {
      var collapse = accordion && mq.matches;

      columns.forEach(function (column, index) {
        if (!collapse) {
          column.open = true;
          return;
        }

        // Remember what the visitor opened, so a resize away and back
        // does not throw their place away.
        if (column.dataset.mcfTouched === 'true') return;
        column.open = index === 0 ? true : false;
      });
    }

    columns.forEach(function (column) {
      column.addEventListener('toggle', function () {
        if (accordion && mq.matches) column.dataset.mcfTouched = 'true';
      });
    });

    if (mq.addEventListener) mq.addEventListener('change', apply);
    else if (mq.addListener) mq.addListener(apply);

    apply();
  }

  function setupBackToTop(footer) {
    var button = footer.querySelector('[data-mcf-top]');
    if (!button) return;

    button.addEventListener('click', function () {
      var reduce =
        window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      window.scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' });
    });
  }

  function init() {
    var footers = document.querySelectorAll('.mcf');
    Array.prototype.forEach.call(footers, function (footer) {
      if (footer.dataset.mcfReady === 'true') return;
      footer.dataset.mcfReady = 'true';
      setup(footer);
      setupBackToTop(footer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
